import React from 'react';
import type { ShopifyOfferDto } from '../../../offer.types';
import { PaymentMethodsSection } from './components/PaymentMethodsSection';
import { StoreInformationSection } from './components/StoreInformationSection';
import { ContactInformationSection } from './components/ContactInformationSection';
import { SecurityBadgeSection } from './components/SecurityBadgeSection';
import { useFooterData } from './hooks/useFooterData';
import type { CheckoutFooterConfig, PaymentBadgeDto, StoreContactDto } from '../../../services/checkoutConfig/checkoutConfig.types';

interface FooterProps {
  shopifyOffer: ShopifyOfferDto;
  config: CheckoutFooterConfig;
  /** Vem do payload de prévia (`GET /store-checkouts/preview/:nanoId`) ou de `shopifyOffer.checkoutTheme`. */
  paymentBadgesOverride?: PaymentBadgeDto[];
  storeContactOverride?: StoreContactDto;
}

const Footer: React.FC<FooterProps> = ({ shopifyOffer, config, paymentBadgesOverride, storeContactOverride }) => {
  const { store, paymentBadges, currentYear } = useFooterData(shopifyOffer, paymentBadgesOverride);

  const contact: StoreContactDto = storeContactOverride ?? shopifyOffer.checkoutTheme.storeContact;
  const email = store.email;
  const backgroundColor = config.backgroundColor || '#000000';
  const textColor = config.textColor || '#FFFFFF';

  return (
    <footer
      className="mt-8 py-6"
      style={{ backgroundColor, color: textColor }}
    >
      <div className="container mx-auto px-4" style={{ color: textColor }}>
        <PaymentMethodsSection
          paymentBadges={paymentBadges}
          enabledPaymentBadgeIds={config.enabledPaymentBadgeIds}
          textColor={textColor}
        />

        <StoreInformationSection
          store={store}
          contact={contact}
          currentYear={currentYear}
          showAddress={config.showAddress}
          showCnpj={config.showCnpj}
          textColor={textColor}
        />

        <ContactInformationSection
          contact={contact}
          email={email}
          showWhatsapp={config.showWhatsapp}
          showPhone={config.showPhone}
          textColor={textColor}
        />

        <SecurityBadgeSection show={config.showSecurityBadge} textColor={textColor} />
      </div>
    </footer>
  );
};

export default Footer;
